import {
  Box,
  BoxProps,
  HStack,
  useCheckbox,
  UseCheckboxProps,
  useColorModeValue as mode,
  useId,
} from "@chakra-ui/react";
import * as React from "react";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";

interface CheckboxProps extends BoxProps {
  isDisabled: boolean;
  isChecked: boolean;
}

const CheckboxBox = (props: CheckboxProps) => {
  const isDisabledChecked = props.isDisabled && props.isChecked;
  return (
    <Box
      borderWidth="2px"
      px="4"
      py="3"
      borderRadius="lg"
      cursor="pointer"
      transition="all 0.2s"
      _focus={{ shadow: "outline" }}
      _checked={{
        bg: "gray.50",
        borderColor: isDisabledChecked ? "gray.300" : "blue.500",
      }}
      {...(props as any)}
    />
  );
};

interface SubjectCheckboxProps extends UseCheckboxProps {
  children: React.ReactNode;
}

export const SubjectCheckbox = (props: SubjectCheckboxProps) => {
  const { children, ...rest } = props;
  const { getCheckboxProps, getInputProps, getLabelProps, state } =
    useCheckbox(rest);
  const id = useId();
  const isDisabledChecked = props.isDisabled && props.isChecked;

  return (
    <label {...(getLabelProps() as any)}>
      <input {...(getInputProps() as any)} aria-labelledby={id} />
      <CheckboxBox
        id={id}
        isChecked={rest.isChecked}
        isDisabled={rest.isDisabled}
        {...(getCheckboxProps() as any)}
      >
        <HStack spacing="4">
          <Box
            data-checked={state.isChecked ? "" : undefined}
            fontSize="2xl"
            _checked={{
              color: mode("blue.500", "blue.300"),
            }}
            color={mode("gray.300", "whiteAlpha.400")}
          >
            {state.isChecked ? (
              <MdCheckBox
                color={
                  isDisabledChecked || rest.isDisabled ? "#BABEC2" : "#0054E5"
                }
              />
            ) : (
              <MdCheckBoxOutlineBlank />
            )}
          </Box>
          <Box fontSize="md" color={isDisabledChecked ? "gray.500" : "inherit"}>
            {children}
          </Box>
        </HStack>
      </CheckboxBox>
    </label>
  );
};
